export default [
  '/additional-information',
  '/purpose',
  '/support',
  '/submit',
  '/cloud-computing',
  '/data-use'
];
